import styled from '@emotion/styled';

export const Container = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
});

export const ContentWrapper = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
});
